import { useRef, useEffect } from "react";
import { useOnScreen, usePrevState, isDefined, objectsEqual } from "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import { ConstructorWidgetEnum } from "../../../shared/types/constructor/widget.js";
import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "react-router";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/pagination/model/slice.js";
import "../../../features/filterChoice/model/middleware/index.js";
import "../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import "../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import { selectFilterValues } from "../../../features/filterChoice/model/selectors/selectFilterValues.js";
import "../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import { selectIsFilterValuesSelected } from "../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import "../../../features/filterChoice/model/slice.js";
import { useConstructorContext } from "../../../shared/context/constructor.js";
import { useConstructorItemByType } from "../../../shared/lib/constructor/hooks/useConstructorItemByType.js";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/lib/logger/index.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { layout, widgets } = useConstructorContext();
  const headerElement = useConstructorItemByType(ConstructorWidgetEnum.VehiclesHeader);
  const anchorRef = useRef(null);
  const isAnchorIntersecting = useOnScreen(anchorRef);
  const filterValues = useAppSelector(selectFilterValues);
  const prevFilterValues = usePrevState(filterValues);
  const isFilterValuesSelected = useAppSelector(selectIsFilterValuesSelected);
  const prevIsFilterValuesSelected = usePrevState(isFilterValuesSelected);
  useEffect(() => {
    const anchorElement = anchorRef.current;
    if (!isDefined(anchorElement)) {
      return;
    }
    if (!isDefined(prevFilterValues) || !isDefined(prevIsFilterValuesSelected)) {
      return;
    }
    const isFiltersChanged = !objectsEqual(prevFilterValues, filterValues);
    const isFilterValuesSelectedChanged = isFilterValuesSelected !== prevIsFilterValuesSelected;
    const scrollToListTop = () => {
      const anchorRect = anchorElement.getBoundingClientRect();
      const headerRect = headerElement == null ? void 0 : headerElement.getBoundingClientRect();
      const targetScrollTop = window.scrollY + anchorRect.top - ((headerRect == null ? void 0 : headerRect.height) ?? 0);
      window.scrollTo({ top: targetScrollTop, behavior: "instant" });
    };
    if ((isFiltersChanged || isFilterValuesSelectedChanged) && !isAnchorIntersecting) {
      window.requestAnimationFrame(scrollToListTop);
    }
  }, [filterValues, isFilterValuesSelected]);
  return {
    ...props,
    layout,
    widgets,
    anchorRef
  };
};
export {
  useContainer
};
